'use client';

import { useAnalyticsConsent } from './AnalyticsConsentProvider';

/**
 * Minimal consent stub for regions that require opt-in (`NEXT_PUBLIC_GA_REQUIRE_CONSENT=true`).
 * Hidden when consent is not required or already decided.
 */
export function AnalyticsConsentBanner() {
  const { consent, requireConsent, grantConsent, denyConsent } =
    useAnalyticsConsent();

  if (!requireConsent || consent !== 'pending') {
    return null;
  }

  return (
    <div
      role='dialog'
      aria-labelledby='analytics-consent-title'
      aria-describedby='analytics-consent-description'
      className='fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card p-4 shadow-lg sm:px-6'
    >
      <div className='mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <div className='space-y-1 text-sm text-foreground'>
          <p id='analytics-consent-title' className='font-medium'>
            Analytics cookies
          </p>
          <p id='analytics-consent-description' className='text-muted-foreground'>
            We use analytics to understand how the adoption quiz is used and improve
            match results. You can accept or decline optional analytics storage.
          </p>
        </div>
        <div className='flex shrink-0 gap-2'>
          <button
            type='button'
            onClick={denyConsent}
            className='rounded-lg border border-border px-3 py-2 text-sm font-medium text-foreground hover:bg-muted'
          >
            Decline
          </button>
          <button
            type='button'
            onClick={grantConsent}
            className='rounded-lg bg-primary-600 px-3 py-2 text-sm font-medium text-white hover:bg-primary-700'
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
